import { ISomastatinAnalog } from './SomastatinAnalog.types';

export const initialSomastinAnalog : ISomastatinAnalog = {
  type: "",
  dose: "",
  weekIntervals: "",
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}